import React from "react";
import { FaHandHoldingHeart, FaPeopleGroup } from "react-icons/fa6";
import { Link } from "react-router-dom";

const ServeSection = () => {
  return (
    <div className="w-full bg-white rounded-lg shadow-lg p-4">
      <h2 className="text-xl font-bold text-gray-800 mb-1">Get Involved</h2>
      <p className="text-sm text-primary font-bold mb-4">See what God can do through you.</p>
      <ul className="w-full">
        <li className="w-full py-2">
          <Link className="flex items-center text-black hover:text-primary transition-colors font-bold" to="/giving">
            <FaHandHoldingHeart className="mr-2 text-lg" />
            <span>Giving</span>
          </Link>
        </li>
        <li className="w-full py-2">
          <Link className="flex items-center text-black hover:text-primary transition-colors font-bold" to="/cell-groups">
            <FaPeopleGroup className="mr-2 text-lg" />
            <span>Cell Ministry</span>
          </Link>
        </li>
       {/* <li className="w-full py-2">
          <Link className="flex items-center text-black hover:text-primary transition-colors font-bold" to="/soul-winning">
            <FaHandsHoldingChild className="mr-2 text-lg" />
            <span>Soul Winning</span>
          </Link>
        </li>*/}
      </ul>
    </div>
  );
};

export default ServeSection;